/**
 * User: Shad
 * Date: 8/13/13
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var Note = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

module.exports = root.bunsen.Note = Note;

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var User = require('bunsen/models/identity/User');
var Seller = require('bunsen/models/Seller');
var Backbone = require('dibs-backbone');
var bunsenLib = require('bunsen/libraries/bunsen');
var Anchors = require('bunsen/collections/Anchors');
var Anchor = require('bunsen/models/Anchor');
var anchorMixin = require('bunsen/models/mixins/anchorMixin');
var Party = require('bunsen/models/Party');
var NOTE_API_TYPE = 'note';
var isType = function (type) {
    return this.get('type') === type;
};

_.extend(Note, {
    // Note Type Tracking:
    // https://docs.google.com/a/1stdibs.com/spreadsheet/ccc?key=0ArUbR02BJMU6dGYya3ZjY2N3YU1PRFFUZFdxc3FtWUE&usp=drive_web#gid=1
    TYPE_ADMIN: 'ADMIN',
    TYPE_BUYER_SELLER: 'BUYER_SELLER',
    TYPE_FIRST_SELLER_OFFER: 'FIRST_SELLER_OFFER',
    TYPE_SELLER_ADMIN: 'SELLER_ADMIN',
    TYPE_SHIPMENT_QUOTE_REQUEST: 'SHIPMENT_QUOTE_REQUEST',
    TYPE_ADMIN_BUYER_ACCOUNT: 'ADMIN_BUYER_ACCOUNT',
    TYPE_ADMIN_SELLER_ACCOUNT: 'ADMIN_SELLER_ACCOUNT',
    TYPE_LISTING_BOOKMARK: 'LISTING_BOOKMARK',
    TYPE_LISTING_PUBLISHING: 'LISTING_PUBLISHING',
    TYPE_ITEM_IMAGING: 'ITEM_IMAGING',
    TYPE_DEALER_IMAGING: 'DEALER_IMAGING',
    TYPE_EXPERT_REVIEW_REJECTION: 'EXPERT_REVIEW_REJECTION',
    TYPE_SELLER_INTERNAL_NOTE: 'SELLER_INTERNAL_NOTE',
    getTypes : function () {
        return [
            Note.TYPE_ADMIN,
            Note.TYPE_BUYER_SELLER,
            Note.TYPE_FIRST_SELLER_OFFER,
            Note.TYPE_SELLER_ADMIN,
            Note.TYPE_SHIPMENT_QUOTE_REQUEST,
            Note.TYPE_ADMIN_BUYER_ACCOUNT,
            Note.TYPE_ADMIN_SELLER_ACCOUNT,
            Note.TYPE_LISTING_BOOKMARK,
            Note.TYPE_ITEM_IMAGING,
            Note.TYPE_DEALER_IMAGING,
            Note.TYPE_EXPERT_REVIEW_REJECTION,
            Note.TYPE_SELLER_INTERNAL_NOTE
        ];
    }
});

_.extend(Note.prototype, {
    idAttribute: "id",
    urlRoot : endpoints.note(),
    defaults: {
        apiType: 'note',
        anchors: []
    },
    url : Backbone.Model.prototype.url,
    initialize: function (attrs, options) {
        attrs = attrs || {};
        this.service = options.service;
        // Leave this here, otherwise a bug in Backbone will overwrite it when they
        // are fetched from the Notes collection.
        // https://github.com/jashkenas/backbone/pull/2426
        this.url = function () {
            return endpoints.note(this.get(this.idAttribute), this.service);
        };
        attrs.apiType = NOTE_API_TYPE;
        this.set('apiType', NOTE_API_TYPE);
        this.stripTags();
        this.on('change:content', this.stripTags);
    },
    relations: function () {
        return [
            {
                key : 'modifiedBy',
                type : Backbone.One,
                relatedModel : SoaModel
            },
            {
                key : 'createdBy',
                type : Backbone.One,
                relatedModel : User
            },
            {
                key: 'anchors',
                collectionType: Anchors,
                type: Backbone.Many
            }
        ];
    },
    stripTags: function () {
        var content = this.get('content');
        if (content) {
            this.set('content', bunsenLib.stripTags(content), { silent: true });
        }
    },
    isFlagged: function () {
        return this.get('flagged') === 'Y';
    },
    getCreatorRole: function () {
        return this.get('createdBy.role');
    },
    createdByBuyer: function () {
        return this.getCreatorRole() === Party.ROLE_BUYER;
    },
    createdBySeller: function () {
        return this.getCreatorRole() === Party.ROLE_SELLER;
    },
    isBuyerSellerType: _.partial(isType, Note.TYPE_BUYER_SELLER),
    isUnanchoredBuyerSellerType: function () {
        return this.isBuyerSellerType() && !this.hasAnchor(Anchor.TYPE_SHIPMENT);
    },
    getCreatorName: function () {
        var profile = this.get('createdBy.profile');
        if (profile) {
            return profile.getDisplayName();
        } else {
            return this.get('createdBy.id');
        }
    },

    /**
     * Get the note's content escaped and ready to put into HTML
     * @param [flaggedCopy] - Replace the note content with this string if it has been flagged
     * @param [tokenReplaceMap] - token replace map for the flagged copy
     */
    getEscapedContent: function (flaggedCopy, copyMap) {
        var noteContent = this.get('content');
        if (!noteContent) {
            return null;
        }

        if (this.isFlagged() && flaggedCopy) {
            if (copyMap) {
                return bunsenLib.tokenReplace(flaggedCopy, copyMap);
            }
            return flaggedCopy;
        }
        return _.escape(noteContent);
    },
    fetchBuyerOrSeller: function (options) {
        if (this.getCreatorRole() === Party.ROLE_SELLER) {
            this.seller = new Seller({id: this.getAnchorIdByType(Party.ROLE_SELLER)});
            return this.seller.fetch(options);
        } else if (this.get('createdBy.id')) {
            return this.get('createdBy').fetch(options);
        }
    }
}, anchorMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Note.js
// module id = 33
// module chunks = 62